import { render } from "./IconInviteLinkError.vue?vue&type=template&id=66ee8474"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconInviteLinkError.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66ee8474"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66ee8474', __exports__)) {
    api.reload('66ee8474', __exports__)
  }
  
  module.hot.accept("./IconInviteLinkError.vue?vue&type=template&id=66ee8474", () => {
    api.rerender('66ee8474', render)
  })

}


export default __exports__